import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.xsell.rblCard.title',
        defaultMessage:
            'Repay with <button>{sweep}%</button> of your eBay revenue'
    },
    alert: {
        id: '_.xsell.rblCard.alert',
        defaultMessage:
            '<bold>Best for Predictability:</bold> Let repayments rise and fall in line with your revenue.'
    },
    pricing: {
        id: '_.xsell.rblCard.pricing',
        defaultMessage: 'Pricing'
    },
    fixedFee: {
        id: '_.xsell.rblCard.fixed_fee',
        defaultMessage: '{fee} fixed fee, no interest'
    },
    repayments: {
        id: '_.xsell.rblCard.repayments',
        defaultMessage: 'Repayments'
    },
    ofRev: {
        id: '_.xsell.rblCard.of_rev',
        defaultMessage:
            '<fetching>{percentage}%</fetching> of eBay revenue <fetching><light>est. {amount}/mo</light></fetching>'
    },
    total: {
        id: '_.xsell.rblCard.total',
        defaultMessage: 'Total repayment'
    },
    input: {
        id: '_.xsell.rblCard.input',
        defaultMessage:
            'Choose the percentage of your monthly revenue to repay with'
    },
    legalText: {
        id: '_.xsell.rblCard.legal_text',
        defaultMessage:
            'Repayments are automatically collected by eBay and we estimate it will take <fetching><bold>{period} months</bold></fetching> to repay the loan. The actual duration will depend upon revenue. Half of the expected repayment is due as a minimum repayment every 60 days. If the minimum repayment is not met, we will collect the difference by direct debit.'
    },
    customise: {
        id: '_.xsell.rblCard.customise',
        defaultMessage: 'Customise repayment'
    },
    continue: {
        id: '_.xsell.rblCard.continue',
        defaultMessage: 'Continue With Offer'
    },
    rblTooltip: {
        id: '_.xsell.rblCard.rbl_tooltip',
        defaultMessage:
            'Revenue repayment possible for loan amounts between {min} - {max}'
    }
});
